module.exports = __webpack_public_path__ + "static/media/svg-2.65e05e17.svg";